import Fronts from './fronts'
import Urtils from './urtils'
import Pantries from './pantries'
import SpiceRacks from './spiceRacks'
import Worktops from './worktops'
import Spacers from './spacers'

export default {
  get(version) {
    const frontsCut = Fronts.get(version.fronts.concat(version.coverPanels), version.materials, version.handles, 'cut') // WIP
    const frontsFinish = Fronts.get(
      version.fronts.concat(version.coverPanels),
      version.materials,
      version.handles,
      'finish'
    )
    const frontsPack = Fronts.get(
      version.fronts.concat(version.coverPanels),
      version.materials,
      version.handles,
      'pack'
    ) // WIP

    const urtilsCut = Urtils.get(version.urtils, version.materials, 'cut')
    const urtilsFinish = Urtils.get(version.urtils, version.materials, 'finish')
    const urtilsAssemble = Urtils.get(version.urtils, version.materials, 'assemble')

    const pantriesCut = Pantries.get(version.pantries, version.materials, 'cut')
    const pantriesFinish = Pantries.get(version.pantries, version.materials, 'finish')
    const pantriesAssemble = Pantries.get(version.pantries, version.materials, 'assemble')

    const spiceRacksCut = SpiceRacks.get(version.spiceRacks, version.materials, 'cut')
    const spiceRacksFinish = SpiceRacks.get(version.spiceRacks, version.materials, 'finish')
    const spiceRacksAssemble = SpiceRacks.get(version.spiceRacks, version.materials, 'assemble')

    const worktops = Worktops.get(version.worktops)
    const spacers = Spacers.get(version.spacerPanels)

    return {
      frontsCut,
      frontsFinish,
      frontsPack,

      urtilsCut,
      urtilsFinish,
      urtilsAssemble,

      pantriesCut,
      pantriesFinish,
      pantriesAssemble,

      spiceRacksCut,
      spiceRacksFinish,
      spiceRacksAssemble,

      worktops,
      spacers
    }
  }
}
